import React from 'react';
import { TransactionCategory } from '@shipstation/financial-services-ui-components';
import PropTypes from 'prop-types';

import { useWalletRegistrationModalContext } from './wallet-registration-modal-context';
import FsuiContextProvider, { SOURCE_WALLET_REGISTRATION } from '../../../../financial-services-ui/fsui-context-provider';

export const ConditionalFsuiContextProvider = ({ children, currencyCode }) => {
  const { shouldShowAdyenDropInComponent, preloadedSession } = useWalletRegistrationModalContext();

  if (shouldShowAdyenDropInComponent) {
    return (
      <FsuiContextProvider
        addtlReturnParams={SOURCE_WALLET_REGISTRATION}
        currencyCode={currencyCode}
        preloadedSession={preloadedSession}
        transactionCategory={TransactionCategory.AddFunds}
      >
        {children}
      </FsuiContextProvider>
    );
  }

  return children;
};

ConditionalFsuiContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  currencyCode: PropTypes.string.isRequired,
};
